export * from './personalDataDossier.component';
